import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import BaseDecorator from '../../base-decorator';
import { AlertsService } from '../../services/alerts.service';
import { BaseService } from '../../shared/services/base.service';
import { DialogService } from '../dialog/dialog.service';
import get from 'lodash-es/get';
import set from 'lodash-es/set';
import { UtilService } from '../../services/util.service';

@Component({
    selector: 'app-csv-json-download',
    templateUrl: './csv-json-download.component.html',
    styleUrls: ['./csv-json-download.component.scss'],
    standalone: false
})
export class CsvJsonDownloadComponent extends BaseDecorator implements OnInit {
  currentConfig: any = {
    config: {
      "submitButton": true,
      "cancelButton": false,
      "filterForm": false,
      "clearOnSave": true,
      "delegateSave": true,
      "allowPagination": true,
      "cancelRoute": ''
    }
  };
  self: this;
  dialogService: DialogService;
  headers: any = [];
  lines: any;
  gridInfo: any = { data: [] };
  utilService: UtilService;
  constructor(public route: ActivatedRoute, public baseService: BaseService, public router: Router, public alerts: AlertsService, public injector: Injector) {
    super(route, 'CsvJsonDownloadComponent');
    if (injector != undefined && injector.get != undefined) {
      this.dialogService = injector.get(DialogService)
      this.utilService = injector.get(UtilService)
    }
    this.self = this;
  }

  ngOnInit(): void {
    this.getResource();
  }

  getResource() {
    this.baseService.getResourceDef("csvJsonDownload", resource => {
      if (resource) {
        this.currentConfig['form'] = resource.form;
      }
    });
  }


  onChange(event) {
    this.currentConfig['fileName'] = event.name;
    var reader = new FileReader()
    reader.readAsText(event, "UTF-7");
    reader.onloadend = () => {
      console.log("file---", event, reader.result);
      this.setHeaders(reader.result, () => {
        this.initiateGrid(() => {
          // this.gridInfo.dataFetched = true
          // this.loader.hideSpinner()
        })
      })
    };
  }

  setHeaders(csvData, callback) {
    if (csvData) {
      csvData = csvData.replace('\r\n', '\n')
      // this.lines = csvData.split('\n');
      this.lines = this.CSVToArray(csvData)
      this.headers = (this.lines[0].toString()).split(',')
      this.lines.shift();
      if (this.lines[this.lines.length - 1] === '')
        this.lines.pop();
      callback()
    }
    // else
    // this.loader.hideSpinner();
  }
  initiateGrid(callback) {
    this.lines.forEach((element, index) => {
      let row = element
      this.gridInfo.data.push({})
      row.forEach((subElem, subIndex) => {
        this.gridInfo.data[index][this.headers[subIndex]] = subElem
      });
    });
    callback()
    // this.loader.hideSpinner()
  }


  CSVToArray(strData, strDelimiter?) {
    // Check to see if the delimiter is defined. If not,
    // then default to comma.
    strDelimiter = (strDelimiter || ",");
    // Create a regular expression to parse the CSV values.
    var objPattern = new RegExp(
      (
        // Delimiters.
        "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +
        // Quoted fields.
        "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +
        // Standard fields.
        "([^\"\\" + strDelimiter + "\\r\\n]*))"
      ),
      "gi"
    );
    // Create an array to hold our data. Give the array
    // a default empty first row.
    var arrData = [[]];
    // Create an array to hold our individual pattern
    // matching groups.
    var arrMatches = null;
    // Keep looping over the regular expression matches
    // until we can no longer find a match.
    while (arrMatches = objPattern.exec(strData)) {
      // Get the delimiter that was found.
      var strMatchedDelimiter = arrMatches[1];
      // Check to see if the given delimiter has a length
      // (is not the start of string) and if it matches
      // field delimiter. If id does not, then we know
      // that this delimiter is a row delimiter.
      if (
        strMatchedDelimiter.length &&
        strMatchedDelimiter !== strDelimiter
      ) {
        // Since we have reached a new row of data,
        // add an empty row to our data array.
        arrData.push([]);
      }
      var strMatchedValue;
      // Now that we have our delimiter out of the way,
      // let's check to see which kind of value we
      // captured (quoted or unquoted).
      if (arrMatches[2]) {
        // We found a quoted value. When we capture
        // this value, unescape any double quotes.
        strMatchedValue = arrMatches[2].replace(
          new RegExp("\"\"", "g"),
          "\""
        );

      } else {
        // We found a non-quoted value.
        strMatchedValue = arrMatches[3];
      }
      // Now that we have our value string, let's add
      // it to the data array.
      arrData[arrData.length - 1].push(strMatchedValue);
    }
    // Return the parsed data.
    return (arrData);
  }



  onSaveFinished(event) {
    try {
      //removing keys
      this.removeKeys(event);
      //decrypt keys
      this.decryptKeys(event);
      //timestamp
      this.convertTime(event);
      //download converted csv
      this.downloadCSVFromJson("converted" + this.currentConfig['fileName'], this.gridInfo.data);
      //reloading the component
      this.reload();

    } catch (error) {
      console.error("error in csv");
    }

  }

  removeKeys(event) {
    if (event.result.removeKeys != undefined && event.result.removeKeys.length > 0) {
      let keys = event.result.removeKeys.split(",");
      for (let item of this.gridInfo.data) {
        for (let key of keys) {
          //this will remove the key
          if (item[key] != undefined) {
            delete item[key];
          }
        }
      }
    }
  }

  convertTime(event) {
    if (event.result.timeStampKeys != undefined && event.result.timeStampKeys.length > 0) {
      let keys = event.result.timeStampKeys.split(",");
      for (let singleResource of this.gridInfo.data) {
        for (let key of keys) {
          let val = get(singleResource, key);
          if (val != undefined) {
            set(singleResource, key, this.utilService.toTimeZoneDateFormat(val, 'datetime'));
          }

        }
      }
    }
  }



  decryptKeys(event) {
    if (event.result.encryptionKeys != undefined && event.result.encryptionKeys.length > 0) {
      let keys = event.result.encryptionKeys.split(",");
      for (let singleResource of this.gridInfo.data) {
        for (let key of keys) {
          let val = get(singleResource, key);
          if (val != undefined && val && this.baseService.decryptText(event.result.encryptionKey, val)) {
            console.log("Encryption vale ::", this.baseService.decryptText(event.result.encryptionKey, val))
            set(singleResource, key, this.baseService.decryptText(event.result.encryptionKey, val));
          }

        }
      }
    }
  }



  downloadCSVFromJson = (filename, arrayOfJson) => {
    // convert JSON to CSV
    const replacer = (key, value) => value === null ? '' : value // specify how you want to handle null values here
    const header = Object.keys(arrayOfJson[0])
    let csv = arrayOfJson.map(row => header.map(fieldName =>
      JSON.stringify(row[fieldName], replacer)).join(','))
    csv.unshift(header.join(','))
    csv = csv.join('\r\n')

    // Create link and download
    var link = document.createElement('a');
    link.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csv));
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  reload() {
    let url = this.formService.baseService.router.url;
    this.formService.baseService.router.navigate(["/search"]).then(() => {
      this.formService.baseService.router.navigateByUrl(url);
    });
  }





}
